<template>
  <div class="sidenav-wrapper">
    <div class="sidenav-container">
      <h1>
        <router-link class="navbar-brand" :to="{ name: 'index' }">
          <img class="img-fluid image_base64" :src="getLogo" alt="Logo" width="100" />
        </router-link>
      </h1>
      <div class="main-content">
        <div class="main-buttons-container">
          <div class="large-header-menu" v-if="componentStyle.header === 'large'">
            <h3 class="subtitle">Menu</h3>
            <a href="#" @click.prevent="setCategory('trends')">
              <i class="fo-icon-home"></i>
              {{ $t('menu.home') }}
            </a>
            <!--<a href="#" @click.prevent="setCategory('trends')">
              <i class="fo-icon-most-watched"></i>{{ categories.trends }}
            </a>-->
            <a href="#" @click.prevent="setCategory('popular')">
              <i class="fo-icon-popular"></i>
              {{ $t('menu.popular') }}
            </a>
            <a href="#" @click.prevent="setCategory('all')">
              <i class="fo-icon-all"></i>
              {{ $t('menu.allVideos') }}
            </a>
          </div>
          <div v-else>
            <button
              class="btn btn-block"
              :class="currentCategory === 'trends' ? 'btn-primary' : 'btn-outline-primary'"
              @click="setCategory('trends')"
            >
              {{ $t('menu.trends') }}
            </button>
            <button
              class="btn btn-block"
              :class="currentCategory === 'popular' ? 'btn-primary' : 'btn-outline-primary'"
              v-on:click="setCategory('popular')"
            >
              {{ $t('menu.popular') }}
            </button>
            <button
              class="btn btn-block"
              :class="currentCategory === 'all' ? 'btn-primary' : 'btn-outline-primary'"
              v-on:click="setCategory('all')"
            >
              {{ $t('menu.all') }}
            </button>
          </div>
        </div>
        <div class="main-menu-container" :class="componentStyle.header + '-header'">
          <h3 class="subtitle" v-if="componentStyle.header === 'large'">Thèmes</h3>
          <button
            v-for="(item, index) in items"
            @click="itemClicked(item.id)"
            :class="['btn btn-block btn-link text-left', { selected: item.id === +currentTheme }]"
            :key="index"
            v-show="item.title"
          >
            {{ item.title }}
          </button>
        </div>
      </div>
      <div class="footer-container">
        <b>© {{ clientName }} {{ currentYear }}</b>
        <p>
          {{ $t('labels.powered_by') }}
          <a href="https://www.empreinte.com/" target="_blank">empreinte.com</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { categories } from '~/static/constants.js';
import Mixin from '@/mixins/Mixin';

export default {
  name: 'SideNav',
  mixins: [Mixin],
  data() {
    return {
      categories,
    };
  },
  computed: {
    ...mapGetters({
      currentCategory: 'videos/getCurrentCategory',
      currentTheme: 'videos/getCurrentTheme',
      items: 'themes/getAllThemes',
      componentStyle: 'layout/getComponentStyle',
      currentLogo: 'layout/getCurrentLogo',
    }),
    currentYear() {
      return new Date().getFullYear();
    },
    clientName() {
      return process.env.CLIENT_NAME;
    },
    getLogo() {
      return this.currentLogo ? this.currentLogo : './static/logo.png?v=1';
    },
  },
  methods: {
    ...mapActions('videos', ['setCurrentCategory']),
    setCategory(category) {
      eventHub.$emit('showCarousel');
      this.setCurrentCategory(category);
      this.$router.push({ name: 'home', params: { category } });
    },
  },
};
</script>

<style scoped lang="scss">
@import '../assets/scss/_variables.scss';

.sidenav-wrapper {
  height: 100vh;
  overflow: auto;
  position: sticky;
  top: 0;
  margin: 0 -15px;
  padding: 0 15px;
  .sidenav-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2em 0 0;
    min-height: 100%;
    align-items: center;
    .main-content {
      flex-grow: 1;
      min-height: 50vh;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      width: 260px;
      max-width: 100%;
      a {
        width: 120px;
        display: inline-block;
      }
      .btn:not(.btn-link):hover {
        color: #ffffff !important;
      }
      .main-buttons-container {
        margin-bottom: 1em;
        .large-header-menu {
          font-size: 1.2em;
          text-align: left;
          padding-left: 1rem;
          color: var(--primary-color);
          .subtitle {
            font-size: 1em;
            margin-bottom: 1em;
          }
          a {
            color: var(--primary-color);
            line-height: 3em;
            font-size: 0.8em;
            text-decoration: none !important;
            width: auto;
            display: block;
            &:hover {
              color: var(--secondary-color);
            }
            i {
              margin-right: 0.5rem;
              font-size: 1.2em;
              color: var(--secondary-color);
              width: 25px;
              display: inline-block;
              text-align: center;
            }
          }
        }
      }
      .main-menu-container {
        margin: 1em 0;
        &.large-header {
          color: var(--primary-color);
          font-size: 1.2em;
          text-align: left;
          padding-left: 1rem;
          .subtitle {
            font-size: 1em;
            margin-bottom: 1em;
          }
          button {
            font-size: 0.8em;
            &:hover,
            &:focus {
              text-decoration: none;
              color: var(--secondary-color);
            }
            &.selected {
              color: var(--secondary-color);
            }
          }
        }
      }
    }
    .footer-container {
      font-size: 0.8em;
      color: #585858;
    }
  }
}
.btn-outline-primary{
  color: var(--secondary-color)!important;
  border-color: var(--secondary-color)!important;
}
.btn-outline-primary:hover{
  color: #fff!important;
  background-color: var(--secondary-color)!important;
  border-color: var(--secondary-color)!important;
}
.btn-outline-primary:focus {
  -webkit-box-shadow: 0 0 0 0.2rem var(--secondary-color)!important;
  box-shadow: 0 0 0 0.2rem var(--secondary-color)!important;
}

</style>



// WEBPACK FOOTER //
// src/components/SideNav.vue